import dayjs from "dayjs";
import type { Location } from "../types";

const isPendingOpportunity = (l: Location) => {
  // is the object empty?
  if (!l.hasOwnProperty("franchiseOpportunity")) return false;

  const today = dayjs().startOf("day");
  // is it a pending opportunity?
  // if (!l.franchiseOpportunity.hasOwnProperty("pendingOpportunity"))
  //   return false;
  // if (l.franchiseOpportunity.pendingOpportunity !== "Yes") return false;

  // does it have a selection timeline?
  if (!l.franchiseOpportunity!.hasOwnProperty("operatorSelectionTimeline"))
    return false;

  //if recruit phase 0 is in the future: don't show
  if (l.franchiseOpportunity!.hasOwnProperty("recruitPhase0Date")) {
    const recruitPhase0Datejs = dayjs(l.franchiseOpportunity.recruitPhase0Date);
    // hide only if recruitPhase0Date is strictly after today
    if (recruitPhase0Datejs.isAfter(today, "day")) {
      return false;
    }
  }

  // if the selection date is 30 days passed: don't show
  if (l.franchiseOpportunity!.hasOwnProperty("recruitPhase5Date")) {
    const recruitPhase5Datejs = dayjs(l.franchiseOpportunity.recruitPhase5Date);
    if (today.isAfter(recruitPhase5Datejs.add(30, "day"))) return false;
  }

  // are all essential date fields parsable dates?
  if (
    new Date(l.franchiseOpportunity.recruitPhase1Date).toString() ===
      "Invalid Date" ||
    new Date(l.franchiseOpportunity.recruitPhase2Date).toString() ===
      "Invalid Date" ||
    new Date(l.franchiseOpportunity.recruitPhase3Date).toString() ===
      "Invalid Date" ||
    new Date(l.franchiseOpportunity.recruitPhase5Date).toString() ===
      "Invalid Date"
  ) {
    return false;
  }

  if (
    new Date(l.franchiseOpportunity.recruitPhase4Date).toString() ===
      "Invalid Date" &&
    l.franchiseOpportunity.operatorSelectionTimeline !== "13 Week"
  ) {
    return false;
  }

  return true;
};

export default isPendingOpportunity;
